/*!
 * KoliBri - The accessible HTML-Standard
 */
import { J as watchJsonArrayString, M as uiUxHintMillerscheZahl } from './common-D-vggmh2.js';

const watchNavLinks = (className, component, value) => {
    watchJsonArrayString(component, '_links', (link) => typeof link === 'object' && (typeof link._href === 'string' || typeof link._label === 'string'), value);
    uiUxHintMillerscheZahl(className, component.state._links.length);
};

export { watchNavLinks as w };
//# sourceMappingURL=validation-BZPzOg5I.js.map

//# sourceMappingURL=validation-BZPzOg5I.js.map